import {
    BadgeArea,
    CardText,
    PriceCard,
    TitleCard,
    DescriptionSection,
} from "./Price.styles";
import { PriceTag } from "./PriceTag";
import { useMemo } from "react";

interface PlanCardProps {
    title: string;
    features: string[];
    price: string;
    badge?: string | null;
    badgeColor?: string;
    badgeTextColor?: string;
}

const normalizeFeatures = (list: string[]) =>
    list
        .flatMap(item => item.split(/\s*-\s*/g)) 
        .map(s => s.trim())
        .filter(Boolean);

export function PlanCard({
    title,
    features,
    price,
    badge,
    badgeColor = "#fff",
    badgeTextColor = "#000",
}: PlanCardProps) {
    const normalizedFeatures = useMemo(() => normalizeFeatures(features), [features]);

    return (
        <PriceCard>
            {badge ? (
                <BadgeArea
                    style={{
                        backgroundColor: badgeColor,
                        color: badgeTextColor,
                    }}
                >
                    {badge}
                </BadgeArea>
            ) : (
                <BadgeArea />
            )}

            <DescriptionSection>
                <TitleCard>{title}</TitleCard>
                {normalizedFeatures.map((f, i) => (
                    <CardText key={`${f}-${i}`}>{f}</CardText>
                ))}
            </DescriptionSection>
            <PriceTag value={price} />
        </PriceCard>
    );
}
